export const NO_USER = 0;
export const GUEST_LOGGED_IN_USER = 1;
export const LOGGED_IN_USER = 2;

export const REGISTER_SECTION_ONE = 1;
export const REGISTER_SECTION_TWO = 2;
export const REGISTER_SECTION_THREE = 3;